<template>
  <el-menu
    class="sidebar-menu"
    :default-active="activeMenu"
    :collapse="isCollapse"
    :collapse-transition="false"
    background-color="#304156"
    text-color="#bfcbd9"
    active-text-color="#409EFF"
    router
  >
    <template v-for="route in menuRoutes">
      <el-menu-item
        v-if="visibleChildren(route).length <= 1"
        :key="route.path"
        :index="resolvePath(route, visibleChildren(route)[0])"
      >
        <i :class="route.meta && route.meta.icon"></i>
        <span slot="title">{{ menuTitle(route) }}</span>
      </el-menu-item>
      <el-submenu v-else :key="route.path" :index="route.path">
        <template slot="title">
          <i :class="route.meta && route.meta.icon"></i>
          <span>{{ route.meta && route.meta.title }}</span>
        </template>
        <el-menu-item
          v-for="child in visibleChildren(route)"
          :key="child.path"
          :index="resolvePath(route, child)"
        >{{ child.meta.title }}</el-menu-item>
      </el-submenu>
    </template>
  </el-menu>
</template>

<script>
import { constantRoutes } from '@/router'

export default {
  name: 'Sidebar',
  computed: {
    menuRoutes () {
      return constantRoutes.filter(r => !r.hidden && r.children)
    },
    activeMenu () {
      return this.$route.path
    },
    isCollapse () {
      return this.$parent && this.$parent.collapse
    }
  },
  methods: {
    visibleChildren (route) {
      return (route.children || []).filter(c => !c.hidden)
    },
    menuTitle (route) {
      if (route.meta && route.meta.title) return route.meta.title
      const first = this.visibleChildren(route)[0]
      return (first && first.meta && first.meta.title) || ''
    },
    resolvePath (parent, child) {
      if (!child) {
        if (parent.children && parent.children.length > 0 && parent.redirect) {
          return parent.redirect
        }
        return '/' + parent.path
      }
      if (parent.path.startsWith('/')) {
        // 根路径 / 不能拼成 //xxx，否则路由匹配不到会 404
        return parent.path === '/' ? '/' + child.path : parent.path + '/' + child.path
      }
      return '/' + parent.path + '/' + child.path
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-menu {
  border-right: none;
  height: calc(100vh - 60px);
}
</style>
